import { render } from "./newsCaunter.vue?vue&type=template&id=25250c16&scoped=true"
import script from "./newsCaunter.vue?vue&type=script&lang=js"
export * from "./newsCaunter.vue?vue&type=script&lang=js"

import "./newsCaunter.vue?vue&type=style&index=0&id=25250c16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25250c16"]])

export default __exports__